import { SupplierStorefrontV2GetResponseType } from "@sellar-io/api-v2/types";

export type SellarDistributionEligibilityResult = {
  isSellarDistributionOnly: boolean;
  hasSdDeliveryArea: boolean;
  isEligible: boolean;
};

export const useSellarDistributionEligibility = (
  supplierStorefront: SupplierStorefrontV2GetResponseType | undefined,
): SellarDistributionEligibilityResult => {
  const isSellarDistributionOnly =
    supplierStorefront?.isSellarDistributionOnly ?? false;
  const hasSdDeliveryArea = !!supplierStorefront?.sdDeliveryArea;
  const hasDeliveryMethod =
    supplierStorefront?.deliveryMethods == null ||
    supplierStorefront.deliveryMethods.length > 0 ||
    supplierStorefront.FulfillmentType.fulfillmentType === "collection";
  const isEligible =
    !(isSellarDistributionOnly && !hasSdDeliveryArea) && hasDeliveryMethod;

  return {
    isSellarDistributionOnly,
    hasSdDeliveryArea,
    isEligible,
  };
};
